<template>
  <div
    v-loading.fullscreen="loading"
    class="app-main-content"
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%">
        <el-tab-pane :lazy="true" :label="$t('AirExport.OtherDocuments')" name="otherDocuments" style="width:100%;height: 100%">
          <batch-upload-file-child
            tab-name="oDocuments"
            :tab-title="$t('AirExport.OtherDocuments')"
            :lob="lob"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('AirExport.CustomsDeclarationDocuments')" name="customsDocuments" style="width:100%;height: 100%">
          <custom-info
            tab-name="cDocuments"
            :tab-title="$t('AirExport.CustomsDeclarationDocuments')"
            :lob="lob"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>

import batchUploadFileChild from '@/components/Cargo/Job/uploadFile/batchUploadFileChild'
import customInfo from '@/components/Cargo/Job/uploadFile/customInfo'

export default {
  name: 'AeUploadFile',
  components: { batchUploadFileChild, customInfo },
  data() {
    return {
      loading: true,
      lob: 'AE',
      activeTabName: 'otherDocuments'
    }
  },
  async created() {
    this.loading = false
  }
}
</script>
